import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _flatten from 'lodash/flatten';
import _isEmpty from 'lodash/isEmpty';
import _isFunction from 'lodash/isFunction';
import { FORM_FIELD_TYPES_VALIDATION_MAP } from './DynamicFormField.constants';
export function getFieldValidationFunction(field, value) {
  var widgetType = field.widgetType;
  var typeToFunction = FORM_FIELD_TYPES_VALIDATION_MAP[widgetType];
  if (_isFunction(typeToFunction)) {
    return typeToFunction(field, value);
  }
  return null;
}
export function validateFormFields(fields, fieldValues) {
  var flattenedFields = _flatten(fields);
  return flattenedFields.map(function (field) {
    var name = field.name;
    var error = getFieldValidationFunction(field, fieldValues[name]);
    return _isEmpty(error) ? null : _defineProperty({}, name, error[name]);
  }).filter(function (error) {
    return error !== null;
  }).reduce(function (acc, error) {
    return _objectSpread(_objectSpread({}, acc), error);
  }, {});
}